export default __webpack_public_path__ + "static/media/points.58a09b23.svg";